export const useFormValidation = (state) => {
  const safeValue = (field) => {
    return state && state[field] ? state[field].valor : '';
  };

  const safeError = (field) => {
    return state && state[field] ? state[field].error : '';
  };

  const conError = (msg) => !!msg;

  return { safeValue, safeError, conError };
};
